import _ from 'lodash'
import { ConvertToMetersObject } from 'admin/lib/Records'

export type estimateRebarWeightInputs = {
  diameter: number
  diameterUoM: string | null | undefined
  length: number
  lengthUoM: string | null | undefined
  quantity: number
}

export const estimateRebarWeight = ({
  diameter,
  diameterUoM,
  length,
  lengthUoM,
  quantity
}: estimateRebarWeightInputs): number => {
  if (diameterUoM === null || diameterUoM === undefined || diameterUoM === '') {
    diameterUoM = 'Millimeter'
  }
  if (lengthUoM === null || lengthUoM === undefined || lengthUoM === '') {
    lengthUoM = 'Millimeter'
  }

  //  162 is a standard industry density constant for Rebar
  const density = 1000 / 162

  const calculatedWeight =
    (diameter * ConvertToMetersObject[diameterUoM]) ** 2 *
    length *
    ConvertToMetersObject[lengthUoM] *
    quantity *
    density
  return _.round(calculatedWeight, 5)
}
